// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DataCacheToolRayType } from '../DataCacheToolEnums';
import { DataCacheTool } from '../DataCacheTool';
export class BaseGannDataCacheTool extends DataCacheTool {
    constructor() {
        super();
        this.InitBlock();
    }
    InitBlock() {
        super.InitBlock();
        this.mirrored = false;
        this.RayType = DataCacheToolRayType.Ray;
    }
}
